import { render, staticRenderFns } from "./VodComparationsCard.vue?vue&type=template&id=2f391f14&"
import script from "./VodComparationsCard.vue?vue&type=script&lang=ts&"
export * from "./VodComparationsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports